module.exports = __webpack_public_path__ + "img/profile_box_career.717939c1.svg";